import { render, staticRenderFns } from "./ThreeLinkage.vue?vue&type=template&id=12cb56fd&scoped=true&"
import script from "./ThreeLinkage.vue?vue&type=script&lang=js&"
export * from "./ThreeLinkage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb56fd",
  null
  
)

export default component.exports